import { FC, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { isNotEmpty } from '@lhb/func';
import { getStorage, setStorage } from '@lhb/cache';
import { mapFilterType } from 'src/views/youth/pages/map/ts-config';
import styles from './index.module.less';
import { Radio } from 'antd';

/** 商圈筛选类型枚举 */
export enum FilterTypeEnum {
  /** 全部 */
  ALL = 'all',
  /** 商场型 */
  Mall = 'mall',
}

/**
 * 商圈筛选类型：全部、商场型；仅在大于1个模型时显示
 */
const Component:FC<{
  /** 筛选类型（筛选类型） */
  value: FilterTypeEnum,
  /** 更新筛选类型到父级，用于更新下面的商圈显示筛选选项 */
  onChange: (value: FilterTypeEnum) => void,
  /** 全部型筛选项 */
  allSelections: any[],
  /** 商场型筛选项 */
  mallSelections: any[],
}> = ({
  value,
  onChange,
  allSelections,
  mallSelections,
}) => {

  /* state */
  const [filterTypeOptions, setFilterTypeOptions] = useState<any[]>([]);
  /** 商圈筛选类型：全部、商场型 */
  const [filterType, setFilterType] = useState<FilterTypeEnum>(value || FilterTypeEnum.ALL);

  /* hooks */
  useEffect(() => {
    // 外部传入，更新当前数据，并缓存
    if (isNotEmpty(value)) {
      setFilterType(value);
      setStorage(mapFilterType, value);
    }
  }, [value]);
  useEffect(() => {
    methods.getSelections();
  }, [allSelections, mallSelections]);

  /* methods */
  const methods = useMethods({

    getSelections() {
      const res: any = [
        { label: '全部', value: 'all', visible: Array.isArray(allSelections) && allSelections.length },
        // 接口返回了 mallSelections 且长度大于0，则展示该选项
        { label: '商场型', value: 'mall', visible: Array.isArray(mallSelections) && mallSelections.length },
      ].filter(item => item.visible);
      const defaultMapFilterType = getStorage(mapFilterType) || FilterTypeEnum.ALL;
      if (res.some(item => item.value === defaultMapFilterType)) {
        methods.changeFilterType(defaultMapFilterType);
      } else {
        methods.changeFilterType(res[0]?.value || FilterTypeEnum.ALL);
      }
      setFilterTypeOptions(res);
    },

    /** 改变筛选类型 */
    changeFilterType(value) {
      setStorage(mapFilterType, value);
      setFilterType(value);
      onChange?.(value);
    },

  });

  return (Array.isArray(filterTypeOptions) && filterTypeOptions.length > 1
    ? <Radio.Group
      value={filterType}
      options={filterTypeOptions}
      className={styles.filterType}
      onChange={e => methods.changeFilterType(e.target.value)}
    />
    : <></>);
};

export default Component;
